<template>
  <v-page page="surveyResponse" title="Aggregated Responses">
    <v-container class="px-0 mx-0 pt-1 mt-3">
      <v-layout>
        <v-select style="width: 50%"
          v-model="searchsurvey"
          placeholder="Survey"
          :items="searchSurveyChoices"
          item-text="name"
          item-value="survey_id"
          @change="search"
          solo
        ></v-select>
        <v-select style="width: 30%"
          v-model="searchSurveyGroup"
          placeholder="Survey Group"
          :items="searchSurveyGroupChoices"
          item-text="name"
          item-value="survey_group_id"
          @change="loadResponses"
          solo
        ></v-select>
        <v-flex xs2 lg1 ml-2 mt-1>
              <v-btn large @click="clearSelection" color="primary">Clear selection</v-btn>
        </v-flex>
      </v-layout>
      <v-layout class="px-0 mx-0 pt-1 mt-3">
        <v-flex>
          <v-select
            v-model="selectQuestion"
            :items="question"
            item-text="question"
            item-value="question_id"
            placeholder="Common Questions"
            @input="loadResponses"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-data-table
            :headers="tableHeaders"
            :items="response"
            :sort-by="['count']"
            :sort-desc="true"
            :options.sync="pagination"
            :loading="loading"
          >
            <template v-slot:item="props">
              <tr>
                <td>{{ props.item.response }}</td>
                <td>{{ props.item.count }}</td>
                <td>{{ props.item.percent }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>
<script>
import VPage from '@/layouts/Default'
import { Bus } from '@/bus'
import UrlParser from '@/core/parsers/Url.parser'

export default {
  name: 'SurveyResonse',
  components: {
    VPage
  },
  data () {
    return {
      selectedQuestion: [],
      searchAssessmentGroup: 'Search assesment group',
      searchsurvey: '',
      searchSurveyGroup: '',
      response: [],
      question: [],
      filter: [],
      selectQuestion: '',
      tableHeaders: [
        { text: 'Responses', value: 'response', sortable: true },
        { text: 'Count', value: 'count', sortable: true },
        { text: 'Percentage (%)', value: 'percent', sortable: false }
      ],
      searchAssessmentGroupChoices: [],
      loading: false,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        page: 1,
        totalItems: 0,
        sortBy: ['filter']
      },
      attribute: '',
      searchSurveyChoices: [],
      searchSurveyGroupChoices: []
    }
  },
  mounted () {
    this.loadSurveys()
    this.loadQuestions()
  },
  computed: {},
  methods: {
    loadQuestions () {
      this.loading = true
      var data = { 'survey': this.searchsurvey }
      this.$store
        .dispatch('surveys/fetchCommonQuestions', data)
        .then(response => {
          this.question = response
        })
        .catch(() => {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to retrieve common questions'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    searchParameters () {
      const query = {
        limit: this.pagination.rowsPerPage,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        order: (this.pagination.descending ? '-' : '+') + this.pagination.sortBy
      }
      let attribute = this.searchAttribute

      if (attribute === 'id') {
        attribute = 'user_assessment_ids'
      }

      let queryStrings = this.query.split(',')
      for (let i = 0; i < queryStrings.length; i++) {
        let string = queryStrings[i]
        if (string.substring(0, 4) === 'http') {
          string = UrlParser.tokens(string)
        }
        queryStrings[i] = string.trim()
      }

      query[attribute] = queryStrings.join(',')

      return query
    },

    loadSurveys () {
      this.loading = true

      var data = {}
      this.$store
        .dispatch('surveys/fetchSurveys', data)
        .then(response => {
          this.searchSurveyChoices = response
        })
        .catch(() => {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to retrieve surveys'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadSurveyGroups () {
      if (this.searchsurvey === '') {
        /* Bus.$emit('alert', { color: 'warning', message: 'No survey selected' }) */
        return
      }
      this.loading = true
      var data = { 'survey': this.searchsurvey }
      this.$store
        .dispatch('surveys/fetchSurveyGroups', data)
        .then(response => {
          this.searchSurveyGroupChoices = response
          this.searchSurveyGroupChoices.push({ 'name': 'All', 'survey_group_id': 'All' })
        })
        .catch(() => {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to retrieve survey groups'
          })
        })
        .finally(() => {
          this.loading = false
          this.response = []
          this.selectedQuestion = []
        })
    },
    loadResponses () {
      if (this.selectQuestion === '') { return }
      this.loading = true

      var data = { 'survey_group_id': this.searchSurveyGroup, 'question_id': this.selectQuestion }

      this.$store
        .dispatch('surveys/fetchResponses', data)
        .then(response => {
          this.response = response
        })
        .catch(() => {
          Bus.$emit('alert', {
            color: 'error',
            message: 'Failed to retrieve responses'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    search () {
      this.loadSurveyGroups()
      this.loadQuestions()
      return true
    },
    clearSelection () {
      this.response = []
      this.searchsurvey = ''
      this.searchSurveyGroup = ''
      this.searchSurveyGroupChoices = []
      this.selectedQuestion = []
      this.selectQuestion = []
    }
  }
}
</script>
<style lang="sass">
.v-btn:not(.v-btn--round).v-size--small
  max-height: 45px
</style>
